import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "C:/Projekte/Experimente/github/react-gsap/node_modules/gatsby-theme-docz/src/base/Layout.js";
import { Fragment } from 'react';
import { Playground, Props } from 'docz';
import { Reveal, SplitLetters } from './../../../react-gsap/src/';
import { Tween, Comment } from './Tween';
import { FadeInLeft, AnimationTrigger, RubberBand } from './Animation';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <h1 {...{
      "id": "reveal"
    }}>{`Reveal`}</h1>
    <p>{`The Reveal component is basically an Intersection Observer and a Timeline component combined.`}</p>
    <p>{`All children Tween and Timeline components get played when they are visible in viewport.`}</p>
    <pre><code parentName="pre" {...{}}>{`import { Reveal, Tween } from 'react-gsap';
`}</code></pre>
    <h2 {...{
      "id": "usage-with-tween"
    }}>{`Usage with Tween`}</h2>
    <p>{`Add a little space for testing`}</p>
    <p>{`|`}</p>
    <p>{`so scroll down`}</p>
    <p>{`|`}</p>
    <p>{`|`}</p>
    <p>{`|`}</p>
    <p>{`|`}</p>
    <p>{`|`}</p>
    <p>{`|`}</p>
    <p>{`|`}</p>
    <p>{`|`}</p>
    <p>{`|`}</p>
    <p>{`|`}</p>
    <Playground __position={0} __code={'<Reveal repeat>\n  <Tween from={{ opacity: 0 }} duration={2}>\n    <h3>This headline is fading in</h3>\n  </Tween>\n</Reveal>'} __scope={{
      props,
      DefaultLayout,
      Fragment,
      Playground,
      Props,
      Reveal,
      SplitLetters,
      Tween,
      Comment,
      FadeInLeft,
      AnimationTrigger,
      RubberBand,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
  <Reveal repeat mdxType="Reveal">
    <Tween from={{
          opacity: 0
        }} duration={2} mdxType="Tween">
      <h3>This headline is fading in</h3>
    </Tween>
  </Reveal>
    </Playground>
    <h2 {...{
      "id": "fade-in-from-left-example"
    }}>{`Fade in from left example`}</h2>
    <p>{`Of course you can outsource animations to separate components. In this example a FadeInLeft animation:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`const FadeInLeft = ({ children }) => (
  <Tween
    from={{ opacity: 0, transform: 'translate3d(-100vw, 0, 0)' }}
    ease="back.out(1.4)"
  >
    {children}
  </Tween>
);
`}</code></pre>
    <p>{`Also note the use of the `}<inlineCode parentName="p">{`trigger`}</inlineCode>{` prop.
In this case the `}<inlineCode parentName="p">{`<H3>`}</inlineCode>{` wouldn't trigger because it's out of the viewport initially: `}<inlineCode parentName="p">{`translate3d(-100vw, 0, 0)`}</inlineCode>{`
If no trigger is passed, the first element from any child Tween or Timeline that gets beyond the threshold is used.`}</p>
    <Playground __position={1} __code={'<Reveal repeat trigger={<div />}>\n  <FadeInLeft>\n    <h3>This headline is coming from left</h3>\n  </FadeInLeft>\n</Reveal>'} __scope={{
      props,
      DefaultLayout,
      Fragment,
      Playground,
      Props,
      Reveal,
      SplitLetters,
      Tween,
      Comment,
      FadeInLeft,
      AnimationTrigger,
      RubberBand,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
  <Reveal repeat trigger={<div />} mdxType="Reveal">
    <FadeInLeft mdxType="FadeInLeft">
      <h3>This headline is coming from left</h3>
    </FadeInLeft>
  </Reveal>
    </Playground>
    <h2 {...{
      "id": "forwardref-trigger"
    }}>{`forwardRef trigger`}</h2>
    <p>{`You can also create a forwardRef component as trigger if you need a more complex wrapper or trigger.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`export const AnimationTrigger = React.forwardRef<HTMLDivElement>(({ children }, ref) => (
  <div
    ref={ref}
    style={{
      paddingTop: '200px',
      paddingBottom: '200px',
      background: '#f0f0f0',
      textAlign: 'center',
    }}
  >
    {children}
  </div>
));

`}</code></pre>
    <Playground __position={2} __code={'<Reveal repeat threshold={1} trigger={<AnimationTrigger />}>\n  <RubberBand>\n    <h2>I get triggered later</h2>\n  </RubberBand>\n</Reveal>'} __scope={{
      props,
      DefaultLayout,
      Fragment,
      Playground,
      Props,
      Reveal,
      SplitLetters,
      Tween,
      Comment,
      FadeInLeft,
      AnimationTrigger,
      RubberBand,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
  <Reveal repeat threshold={1} trigger={<AnimationTrigger mdxType="AnimationTrigger" />} mdxType="Reveal">
    <RubberBand mdxType="RubberBand">
      <h2>I get triggered later</h2>
    </RubberBand>
  </Reveal>
    </Playground>
    <h2 {...{
      "id": "props"
    }}>{`Props`}</h2>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Default`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`children`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`React.ReactNode`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}></td>
          <td parentName="tr" {...{
            "align": "left"
          }}></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`trigger?`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`React.ReactElement `}{`|`}{` null`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`This element triggers the animation if it gets into view. Needs to be a "refable" element like HTML element or forwardRef component`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`repeat?`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`boolean`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`false`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Trigger the animation again and again?`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`root?`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Element `}{`|`}{` null`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`null`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`rootMargin?`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`string`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`0px`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`threshold?`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`number`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`0.66`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`As opposed to the threshold value from IntersectionObserver options this is just a single number`}</td>
        </tr>
      </tbody>
    </table>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      